/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { ComponentChildren } from 'preact';


import { gridInterpolations } from '../utils/UNSAFE_interpolations/grid';
import type { GridProps } from '../utils/UNSAFE_interpolations/grid';
import { boxAlignmentInterpolations } from '../utils/UNSAFE_interpolations/boxalignment';
import type { BoxAlignmentProps } from '../utils/UNSAFE_interpolations/boxalignment';
import { mergeInterpolations } from '../utils/UNSAFE_mergeInterpolations';
import { baseStyles } from './GridStyles.css';

type Props = GridProps &
  BoxAlignmentProps & {
    /**
     * The children to put in the grid.
     */
    children?: ComponentChildren;
  };



const interpolations = [
  ...Object.values(gridInterpolations),
  ...Object.values(boxAlignmentInterpolations)
];

const styleInterpolations = mergeInterpolations<Props>(interpolations);

/**
 * An implicit grid. Resize your browser to see how items reflow.
 */
export const Grid = ({ children, ...props }: Props) => {
  const { class: cls, ...styles } = styleInterpolations(props);
  const allStyles = { ...styles };
  return (
    <div class={`${baseStyles} ${cls}`} style={allStyles}>
      {children}
    </div>
  );
};
